import type { AuthService } from "@storytell/auth";
import type { SyncService } from "../sync/syncStore";
import type { ChatService } from "../chat/chatService";
import { createSignal } from "solid-js";
import { makePersisted } from "@solid-primitives/storage";
import { isServer } from "solid-js/web";

export type GuidesService = ReturnType<typeof createGuidesService>;
/**
 * Guides are a way to help users get started with the app.
 * They can affect the UI for both new users and returning users depending
 * on various factors, like number of chats, if they have uploaded assets, etc.
 */
export const createGuidesService = (deps: {
  authService: AuthService;
  syncService: SyncService;
  chatService: ChatService;
}) => {
  const firstTimeUploading = makePersisted(createSignal(true), {
    name: "v1:guide:first-upload",
    storage: isServer ? undefined : localStorage,
  });

  return {
    firstTimeUploading,
  };
};
